import styled, { css, keyframes } from "styled-components";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
`;

export const Button = styled.button`
  padding: 12px 25px;
  border: none;
  border-radius: 20px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  ${(props) =>
    props.$primary &&
    `
    background: var(--gradient-primary);
    color: var(--surface);

    &:hover:not(:disabled) {
      background: var(--accent-dark);
      color: var(--surface);
      transform: translateY(-2px);
    }
  `}

  svg {
    animation: ${(props) =>
      props.$loading
        ? css`
            ${spin} 1s ease-in-out infinite
          `
        : "none"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Section = styled.div`
  background: var(--surface);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--accent-light);
`;

export const SectionSubTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionHint = styled.p`
  font-size: 13px;
  color: var(--text-muted);
  margin: -10px 0 20px 0;
  line-height: 1.5;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) =>
    props.$active ? "var(--success)" : "var(--text-muted)"};
`;

export const ToggleSwitch = styled.button`
  position: relative;
  width: 52px;
  height: 28px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
  background: ${(props) =>
    props.$on ? "var(--success)" : "var(--accent-light)"};
  flex-shrink: 0;

  &::after {
    content: "";
    position: absolute;
    top: 3px;
    left: ${(props) => (props.$on ? "27px" : "3px")};
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--surface);
    transition: left 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--accent-light);
  border-radius: 12px;
  font-family: inherit;
  font-size: 14px;
  background: var(--surface);
  color: var(--text-primary);
  outline: none;
  transition: all 0.3s ease;

  &:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(124, 14, 51, 0.1);
  }

  &::placeholder {
    color: var(--text-muted);
  }
`;

export const CharCount = styled.div`
  font-size: 11px;
  color: ${(props) => (props.$over ? "var(--error)" : "var(--text-muted)")};
  text-align: right;
  margin-top: 6px;
`;

export const PreviewBar = styled.div`
  background: var(--gradient-primary);
  color: var(--surface);
  font-size: 13px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: ${(props) => (props.$dimmed ? 0.45 : 1)};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
`;
